import { parseStatLines } from "./parse";

interface KpiCardsProps {
  content: string;
}

export function KpiCards({ content }: KpiCardsProps) {
  const items = parseStatLines(content);
  if (items.length === 0) return null;

  return (
    <div className="cx-kpi">
      {items.map((item, i) => (
        <div key={i} className="cx-kpi-item">
          <div className={`cx-kpi-value${i === 0 ? " cx-kpi-value--accent" : ""}`}>
            {item.value}
          </div>
          <div className="cx-kpi-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
